<template>
  <div class="act-intro-wrap blue-bg">
    <!-- 预留活动介绍横幅切图 -->
    <img class="intro-title" :src="introTitle" />
    <div class="intro-text-wrap">
      <!-- <p class="intro-sub-title">{{ $t('wc2026.intro.subTitle') }}</p> -->
      <p class="intro-content-text">{{ $t('wc2026.intro.contentText') }}</p>
    </div>
    <div class="intro-bottom-wrap">
      <img class="intro-bottom-img" :src="bottomLogo" />
      <div class="footer-box-wrap btn" @click="showRule">
        <img class="footer-box" :src="footerBox" />
        <img class="footer-hand" :src="footerHand" />
      </div>
    </div>
    <RuleDialog v-model="ruleDialog" />
  </div>
  </template>
  
  <script setup>
  import { computed, ref } from 'vue'
  import introTitleVi from '@/assets/imgs/act/wc2026/intro/titlevi.png'
  import introTitleTh from '@/assets/imgs/act/wc2026/intro/titleth.png'
  import introTitleId from '@/assets/imgs/act/wc2026/intro/titleid.png'
  import introTitleZh from '@/assets/imgs/act/wc2026/intro/titlezh.png'
  import introTitleEn from '@/assets/imgs/act/wc2026/intro/titleen.png'
  import bottomLogo from '@/assets/imgs/act/wc2026/intro/bottomLogo.png'
  import footerBox from '@/assets/imgs/act/wc2026/intro/footerball.png'
  import footerHand from '@/assets/imgs/act/wc2026/intro/hander.png'
  import { useI18n } from 'vue-i18n'
  import RuleDialog from '../RuleDialog/index.vue'

const ruleDialog = ref(false)
const showRule = () => {
  ruleDialog.value = true
}
const locale = useI18n().locale
console.log('locale', locale)
  const introTitle = computed(() => {
  
    switch (locale.value) {
      case 'vi':
        return introTitleVi
      case 'th':
        return introTitleTh
      case 'id':
        return introTitleId
      case 'en':
        return introTitleEn
      case 'tw':
        return introTitleZh
      case 'hk':
        return introTitleZh
      default:
        return introTitleEn
    }
  })

  
  </script>
  
  <style lang="less" scoped>
  .act-intro-wrap {
    padding-top: 48px; 
   .intro-title {
     display: block;
     width: auto;
     margin: 0 auto;
     height: 47px;
     object-fit: cover;
     margin-bottom: 14px;
   }
 
   .intro-text-wrap {
    margin-bottom: 9px;
    width: 642px;
    margin: auto;
    color: #1B0926;
    text-align: center;
    font-size: 17px;
    line-height: 1.5;
    text-align: left;
    .intro-sub-title {
      margin-bottom: 30px;
     }
     .intro-content-text {
     }

   }

   .intro-bottom-wrap {
    position: relative;
    height: 60px;
    .footer-box {
      width: 120px;
      height: 120px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      margin-top: -20px;
     }
     .footer-hand {
      width: 69px;
      height: 58px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      margin-left: 68px;
      margin-top: 10px;
     }
     .intro-bottom-img {
      display: block;
      height:43px;
      width: auto;
      margin: auto;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
     }
   }

 }
  </style>